import { useEffect, useRef } from 'react';

export const DASHBOARD_REFRESH_EVENT = 'cti:dashboard_refresh';
const DEFAULT_JITTER_MS = 2000;

export type DashboardRefreshDetail = { sections?: string[]; jitterMs?: number };

export function useDashboardRefresh(section: string, load: () => unknown, enabled = true) {
  const loadRef = useRef(load);
  loadRef.current = load;

  useEffect(() => {
    if (!enabled) return undefined;
    let timer: ReturnType<typeof setTimeout> | null = null;
    const onRefresh = (e: Event) => {
      const detail = (e as CustomEvent<DashboardRefreshDetail>).detail || {};
      if (!Array.isArray(detail.sections) || !detail.sections.includes(section) || timer) return;
      const jitter = Number(detail.jitterMs) >= 0 ? Number(detail.jitterMs) : DEFAULT_JITTER_MS;
      timer = setTimeout(() => {
        timer = null;
        try { loadRef.current?.(); } catch { /* the section keeps its last data */ }
      }, Math.random() * jitter);
    };
    window.addEventListener(DASHBOARD_REFRESH_EVENT, onRefresh);
    return () => {
      window.removeEventListener(DASHBOARD_REFRESH_EVENT, onRefresh);
      if (timer) clearTimeout(timer);
    };
  }, [section, enabled]);
}
